<template>
	<div>
		<navpage
			ref="navPage"
			:middle="true"
			pagename="trendValidation"
			:displayDates="true"
			:displayFilters="false"
			:updateParameters="false"
			:displayAllButton="false"
			@datepickercreated="setDates()"
			@changedate="changeDate($event)"
		></navpage>

		<div id="content-page">
			<newtrendfilter
				ref="newtrendfilter"
				v-bind="{ showCreateTrends: true, selectedDate: date }"
				@trendfilters="trendFilters($event)"
				@updatetrends="updateTrends"
			></newtrendfilter>
			<div class="row dynvibeRow">
				<div class="col-lg-12 dynvibeBox">
					<div class="col-lg-12 dynvibeTitleBox">
						<h2>Categories EcoSystem</h2>
					</div>
					<networkchart v-bind="$data"></networkchart>
				</div>
			</div>
			<div v-show="showOtherCharts" class="row dynvibeRow">
				<div class="col-lg-12 dynvibeBox">
					<div class="col-lg-12 dynvibeTitleBox">
						<h2>Trending Topics Dynamic</h2>
					</div>
					<dynamichart v-bind="$data" @clicked="showTopic($event)"></dynamichart>
				</div>
			</div>
			<div v-show="showOtherCharts" class="row dynvibeRow">
				<div class="col-lg-12 dynvibeBox">
					<div class="col-lg-12 dynvibeTitleBox">
						<h2>Buzzing Topics</h2>
					</div>
					<buzzinglist
						class="col-lg-6"
						ref="buzzinglist_tops"
						:type="'tops'"
						v-bind="$data"
						@clicked="showTopic($event)"
					></buzzinglist>
					<buzzinglist
						class="col-lg-6"
						ref="buzzinglist_flops"
						:type="'flops'"
						v-bind="$data"
						@clicked="showTopic($event)"
					></buzzinglist>
				</div>
			</div>
			<trendmodal ref="createTrend" :type="'trend'" @updatetrends="updateTrends"></trendmodal>
		</div>
	</div>
</template>
<script>
import navpage from "@/components/globalVue/Nav.vue";
//import confirm from ".@/components/globalVue/Confirm.vue";
import newtrendfilter from "@/components/globalVue/NewTrendFilter.vue";
import dynamichart from "@/components/vueCharts/DynvibeDynamic.vue";
import buzzinglist from "@/components/trend/BuzzingList.vue";
import networkchart from "@/components/vueCharts/DynvibeNetwork.vue";
import trendmodal from "@/components/incoming/CreateMastertag.vue";
//import editcreatemodal from "@/components/trend/editCreateModal.vue";

export default {
	name: "trendvalidation",
	data() {
		return {
			panel: "",
			segment: "",
			date: { gte: "", lte: "" },
			country: "",
			category: "",
			subcategory: "",
			mastertag: "",
			showOtherCharts: false,
			trendfilters: {},
		};
	},
	components: {
		navpage: navpage,
		//confirm: confirm,
		newtrendfilter: newtrendfilter,
		dynamichart: dynamichart,
		buzzinglist: buzzinglist,
		networkchart: networkchart,
		trendmodal: trendmodal,
		//editcreatemodal: editcreatemodal,
	},
	methods: {
		trendFilters(val) {
			this.panel = val.panel;
			this.segment = val.segment;
			this.date = val.date;
			this.country = val.country;
			this.category = val.category;
			this.subcategory = val.subcategory;
			this.mastertag = val.mastertag;
			if (this.date.gte !== "") {
				this.showOtherCharts = true;
			} else {
				this.showOtherCharts = false;
			}
			//this.trendfilters = val;
			this.$refs.createTrend.fillData(val, "trendfilters");
		},
		showTopic(topic) {
			let avgGrowth = 0;
			this.$axios
				.post(this.$backendUrl + "avgGrowth", this.$Qs.stringify({ label: topic.topic, date: this.date }))
				.then((response) => {
					avgGrowth = response.data.avg;
					this.$refs.createTrend.fillData({
						mainkeyword: topic.topic,
						level: "mastertag",
						periodGrowth: topic.periodGrowth,
						avgGrowth: Math.round(avgGrowth * 100) / 100,
						fire: topic.rank < 100 && topic.periodGrowth > 10,
					});
				});
		},
		updateTrends() {
			this.$refs.buzzinglist_tops.checkFilters();
			this.$refs.buzzinglist_flops.checkFilters();
		},
		setDates() {
			/*            let today = moment().format("YYYY-MM-DD");
						let threeMonthsAgo = moment().subtract(3, "month").format("YYYY-MM-DD");
						this.date = {'gte': threeMonthsAgo, 'lte': today}*/
			this.$refs.navPage.setDates(null, null);
		},
		changeDate($event) {
			this.date.gte = $event.gte;
			this.date.lte = $event.lte;
			this.updateTrends();
		},
	},
};
</script>

<style></style>
